export const navigationActions = {
  CLICK_TOP_NAV_SHARE: "CLICK_TOP_NAV_SHARE",
  CLICK_SIDE_NAV_ITEM: "CLICK_SIDE_NAV_ITEM",
} as const;
